import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { useEntraOAuthSignIn } from '../../hooks/useEntraOAuthSignIn';
  import {
	Progress,
	ErrorPanel,
  } from '@backstage/core-components';
import { Box, Typography, Button } from '@material-ui/core';
import { EntraOAuthContext } from '../../hooks/useEntraOAuthContext';
import { useEffect } from "react";

export const EntraOAuthWrapper = ({
	...props
}: FieldExtensionComponentProps<string, { title?: string, message?: string, onTokenChange?: (token: string | undefined) => void }> & {
    scopes: string[];
	sessionKey: string;
	onTokenChange?: (token: string | undefined) => void;
}) => {
	const { token, loading, error, showSignInModal, isSignedIn } = useEntraOAuthSignIn({
		scopes: (props.scopes ?? []),
		sessionKey: props.sessionKey
	});

	useEffect(() => {
		if (props.onTokenChange) {
			props.onTokenChange(isSignedIn ? token : undefined);
		}
	}, [token, isSignedIn, props.onChange]);

	if (loading && !isSignedIn) {
		return <Progress />;
	}

	if (error) {
		return <ErrorPanel error={error} />;
	}

	if (!isSignedIn || !token) {
		return (
			<Box height="100%" width="100%">
				<Box>
					<Typography variant="body2">
						<b>{props.uiSchema['ui:options']?.title ?? props.name}</b>
					</Typography>
				</Box>
				<Box display="flex">
					<Box paddingRight={1}>
						<Typography>
							{props.uiSchema['ui:options']?.message ?? 'This input requires authentication with Azure DevOps.'}
						</Typography>
					</Box>
					<Box>
						<Button
							variant="outlined"
							color="primary"
							onClick={showSignInModal}
						>
							Sign in
						</Button>
					</Box>
				</Box>
			</Box>
		);
	}

	return (
        <EntraOAuthContext.Provider value={{ token }}>
            {props.children}
        </EntraOAuthContext.Provider>
	);
    
};